import { IntegrationTypesActionTypes } from './constants';

const INIT_STATE = {
    loading: false,
    error: null,
    integrationTypes: null,
};

type IntegrationTypesAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};

type State = {
    loading: Boolean,
    error?: null,
    integrationTypes: any,
};

const IntegrationTypes = (state: State = INIT_STATE, action: IntegrationTypesAction): any => {
    switch (action.type) {
        case IntegrationTypesActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case IntegrationTypesActionTypes.GET_ALL_INTEGRATION_TYPES: {
                    return {
                        ...state,
                        loading: false,
                        integrationTypes: action.payload.data.integrationTypes,
                    };
                }
                default:
                    return { ...state, loading: false };
            }

        case IntegrationTypesActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case IntegrationTypesActionTypes.GET_ALL_INTEGRATION_TYPES: {
                    return { ...state, loading: false, error: action.payload.error };
                }
                default:
                    return { ...state, loading: false };
            }

        case IntegrationTypesActionTypes.GET_ALL_INTEGRATION_TYPES:
            return { ...state, loading: true, integrationTypes: null };
        case IntegrationTypesActionTypes.RESET_STATE:
            return INIT_STATE;
        case IntegrationTypesActionTypes.RESET_ALL_ERRORS:
            return { ...state, error: null };
        default:
            return { ...state };
    }
};

export default IntegrationTypes;